import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Tabs from "../../components/common/Tabs";

const tabs = [
  {
    link: "/people/tenants",
    title: "Tenants",
  },
  {
    link: "/people/owners",
    title: "Owners",
  },
  {
    link: "/people/vendors",
    title: "vendors",
  },
];

function People() {
  return (
    <div className="page-container">
      <div className="main-container">
        <Tabs tabs={tabs} keepFirstLinkActive={true}/>
        <Outlet />
        {/* Footer  */}
        <Footer />
      </div>
    </div>
  );
}

export default People;
